import { extend } from 'flarum/common/extend';
export default function userDirectry(app) {
  extend('ext:fof/user-directory/common/utils/SortMap', 'sortMap', function (map) {
    map['most_exp'] = '-exp';
    map['least_exp'] = 'exp';
  });
}
flarum.reg.add('foskym-custom-levels', 'forum/integrations/userDirectory', userDirectry);